export default __webpack_public_path__ + "assets/img/defaultcourse.52924a84508074f6721762ae3a639ab1.png";